import { render, staticRenderFns } from "./DisburstmentList.vue?vue&type=template&id=f519fc82&scoped=true"
import script from "./DisburstmentList.vue?vue&type=script&lang=js"
export * from "./DisburstmentList.vue?vue&type=script&lang=js"
import style0 from "./DisburstmentList.vue?vue&type=style&index=0&id=f519fc82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f519fc82",
  null
  
)

export default component.exports